import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const reportLimit = {
  path: '/reportLimit',
  component: Layout,
  name: 'reportLimit',
  redirect: '/reportLimit/index',
  children: [
    {
      path: '/reportLimit/index',
      component: () => import('@/views/reportLimit/index'),
      name: 'reportLimit/index',
      meta: { title: i18n.t(`message.type_expences`)}
    },
  ]
}

export default reportLimit